/* Fabric Alex product-card colour swatches:
   continuous loop + independent touch/drag control per product card. */
(function () {
  'use strict';

  var SELECTOR = '.fa-product-card .color-swatch-list';
  var SPEED = 34;
  var RESUME_DELAY = 750;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var states = [];

  function removeOldClones(list) {
    Array.prototype.slice.call(list.children).forEach(function (child) {
      if (child.classList.contains('fa-swatch-clone')) {
        child.remove();
      }
    });
  }

  function getOriginals(list) {
    return Array.prototype.slice.call(list.children).filter(function (child) {
      return child.classList.contains('color-swatch');
    });
  }

  function createVisualClone(source, index) {
    var clone = document.createElement('div');
    clone.className = 'fa-swatch-clone';
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-fa-swatch-index', String(index));

    var sourceVisual = source.querySelector('.color-swatch__item');
    if (sourceVisual) {
      var visualClone = document.createElement('span');
      visualClone.className = 'fa-swatch-clone__item';

      var sourceStyle = sourceVisual.getAttribute('style');
      if (sourceStyle) {
        visualClone.setAttribute('style', sourceStyle);
      }

      clone.appendChild(visualClone);
    }

    return clone;
  }

  function appendCloneCycle(state) {
    state.originals.forEach(function (source, index) {
      state.list.appendChild(createVisualClone(source, index));
    });
  }

  function normalizePosition(state) {
    if (state.cycleWidth <= 0) return;

    var position = state.list.scrollLeft;

    if (position >= state.cycleWidth || position < 0) {
      position = ((position % state.cycleWidth) + state.cycleWidth) % state.cycleWidth;
      state.list.scrollLeft = position;
    }
  }

  function ensureCoverage(state) {
    if (!state.firstOriginal || !state.firstClone) return;

    state.cycleWidth = state.firstClone.offsetLeft - state.firstOriginal.offsetLeft;
    if (state.cycleWidth <= 0) return;

    while (state.list.scrollWidth < state.cycleWidth + state.list.clientWidth + 16) {
      appendCloneCycle(state);
    }

    normalizePosition(state);
  }

  function pauseForUser(state) {
    state.userPaused = true;
    state.lastFrame = null;

    if (state.resumeTimer) {
      window.clearTimeout(state.resumeTimer);
      state.resumeTimer = null;
    }
  }

  function scheduleResume(state, delay) {
    if (state.resumeTimer) {
      window.clearTimeout(state.resumeTimer);
    }

    state.resumeTimer = window.setTimeout(function () {
      state.resumeTimer = null;
      normalizePosition(state);
      state.userPaused = false;
      state.lastFrame = null;
    }, typeof delay === 'number' ? delay : RESUME_DELAY);
  }

  function bindInteraction(state) {
    var list = state.list;

    function beginInteraction(clientX) {
      pauseForUser(state);
      state.startX = clientX;
      state.didDrag = false;
    }

    function updateDrag(clientX) {
      if (state.startX === null || typeof clientX !== 'number') return;

      if (Math.abs(clientX - state.startX) > 7) {
        state.didDrag = true;
      }
    }

    function endInteraction() {
      state.startX = null;
      scheduleResume(state, RESUME_DELAY);
    }

    if ('PointerEvent' in window) {
      list.addEventListener('pointerdown', function (event) {
        beginInteraction(event.clientX);
      }, { passive: true });

      list.addEventListener('pointermove', function (event) {
        updateDrag(event.clientX);
      }, { passive: true });

      list.addEventListener('pointerup', endInteraction, { passive: true });
      list.addEventListener('pointercancel', endInteraction, { passive: true });
    } else {
      list.addEventListener('touchstart', function (event) {
        var touch = event.touches && event.touches[0];
        beginInteraction(touch ? touch.clientX : null);
      }, { passive: true });

      list.addEventListener('touchmove', function (event) {
        var touch = event.touches && event.touches[0];
        updateDrag(touch ? touch.clientX : null);
      }, { passive: true });

      list.addEventListener('touchend', endInteraction, { passive: true });
      list.addEventListener('touchcancel', endInteraction, { passive: true });
    }

    list.addEventListener('wheel', function () {
      pauseForUser(state);
      scheduleResume(state, RESUME_DELAY);
    }, { passive: true });

    list.addEventListener('scroll', function () {
      if (state.userPaused) {
        scheduleResume(state, RESUME_DELAY);
      }
    }, { passive: true });

    list.addEventListener('click', function (event) {
      var clone = event.target.closest('.fa-swatch-clone');
      if (!clone) return;

      event.preventDefault();

      if (state.didDrag) {
        state.didDrag = false;
        return;
      }

      var index = parseInt(clone.getAttribute('data-fa-swatch-index'), 10);
      var source = state.originals[index];
      if (!source) return;

      var input = source.querySelector('.color-swatch__radio');
      if (input) {
        input.click();
      }
    });
  }

  function animateState(state, now) {
    if (!document.documentElement.contains(state.list)) {
      return;
    }

    if (state.lastFrame === null) {
      state.lastFrame = now;
    }

    var delta = Math.min(now - state.lastFrame, 50);
    state.lastFrame = now;

    if (!reduceMotion.matches && !state.userPaused && state.cycleWidth > 0) {
      state.list.scrollLeft += SPEED * delta / 1000;

      if (state.list.scrollLeft >= state.cycleWidth) {
        state.list.scrollLeft -= state.cycleWidth;
      }
    }

    state.rafId = window.requestAnimationFrame(function (nextNow) {
      animateState(state, nextNow);
    });
  }

  function initList(list) {
    if (!list || list.dataset.faSwatchMarqueeReady === 'true') return;

    removeOldClones(list);

    var originals = getOriginals(list);
    if (originals.length < 2) return;

    list.dataset.faSwatchMarqueeReady = 'true';

    var state = {
      list: list,
      originals: originals,
      firstOriginal: originals[0],
      firstClone: null,
      cycleWidth: 0,
      userPaused: false,
      resumeTimer: null,
      lastFrame: null,
      rafId: null,
      startX: null,
      didDrag: false
    };

    appendCloneCycle(state);
    state.firstClone = list.children[originals.length];

    ensureCoverage(state);
    bindInteraction(state);
    states.push(state);

    state.rafId = window.requestAnimationFrame(function (now) {
      animateState(state, now);
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches(SELECTOR)) {
      initList(scope);
    }

    scope.querySelectorAll(SELECTOR).forEach(initList);
  }

  function handleResize() {
    states.forEach(function (state) {
      if (document.documentElement.contains(state.list)) {
        ensureCoverage(state);
      }
    });
  }

  function handleMotionChange(event) {
    states.forEach(function (state) {
      if (event.matches) {
        state.list.scrollLeft = 0;
        state.lastFrame = null;
      } else {
        normalizePosition(state);
        state.lastFrame = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes, function (node) {
          if (node.nodeType === 1 && !node.classList.contains('fa-swatch-clone')) {
            initAll(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('resize', handleResize);

  if (reduceMotion.addEventListener) {
    reduceMotion.addEventListener('change', handleMotionChange);
  } else if (reduceMotion.addListener) {
    reduceMotion.addListener(handleMotionChange);
  }
})();

/* Fabric Alex PDP trust localisation + obsolete shipping-estimator cleanup. */
(function () {
  'use strict';

  var STYLE_ID = 'fa-pdp-trust-shipping-fix-v1';

  function isBulgarian() {
    return /^bg(?:-|$)/i.test(document.documentElement.getAttribute('lang') || '');
  }

  function installStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      'body.warehouse--v1.template-product .product-block-list__item--trust .card__title,body.warehouse--v1.template-product .product-block-list__item--trust .payment-list__notice{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif!important;}',
      'body.warehouse--v1.template-product .product-block-list__item--trust .card__title{font-weight:800!important;letter-spacing:-.02em!important;line-height:1.15!important;}',
      'body.warehouse--v1.template-product .product-block-list__item--trust .payment-list__notice{font-size:15px!important;font-weight:500!important;line-height:1.55!important;letter-spacing:0!important;}',
      'body.warehouse--v1.template-product .product-block-list__item--shipping.fa-refund-policy-only>.card{overflow:hidden!important;}',
      'body.warehouse--v1.template-product .product-block-list__item--shipping.fa-refund-policy-only>.card>.card__section--tight{padding-top:16px!important;padding-bottom:16px!important;border-top:0!important;}'
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  function localizeTrustCard() {
    if (!document.body || !document.body.classList.contains('template-product')) return;

    var trust = document.querySelector('.product-block-list__item--trust');
    if (!trust || !isBulgarian() || trust.getAttribute('data-fa-trust-localized') === 'bg') return;

    var title = trust.querySelector('.card__title');
    var notice = trust.querySelector('.payment-list__notice');

    if (title) title.textContent = 'Сигурно плащане';
    if (notice) notice.textContent = 'Данните за плащане се обработват по защитен начин. Fabric Alex не съхранява и няма достъп до пълните данни на банковата ви карта.';

    trust.setAttribute('data-fa-trust-localized', 'bg');
  }

  function removeShippingEstimator() {
    if (!document.body || !document.body.classList.contains('template-product')) return;

    var block = document.querySelector('.product-block-list__item--shipping');
    if (!block || block.getAttribute('data-fa-estimator-removed') === 'true') return;

    var card = block.querySelector(':scope > .card');
    if (!card) return;

    var refund = card.querySelector(':scope > .card__section--tight');
    var children = Array.prototype.slice.call(card.children);

    children.forEach(function (child) {
      if (refund && child === refund) return;
      child.remove();
    });

    if (refund) {
      block.classList.add('fa-refund-policy-only');
      block.setAttribute('data-fa-estimator-removed', 'true');
    } else {
      block.remove();
    }
  }

  function run() {
    installStyle();
    localizeTrustCard();
    removeShippingEstimator();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
